export async function loadAppSettings() {
  const response = await fetch(`${process.env.BASE_URL}app-settings.json`, {
    cache: 'no-store'
  })

  if (!response.ok) {
    throw new Error(`Unable to load app-settings.json (${response.status})`)
  }

  return response.json()
}
